import { memo } from 'react';

import { Flex, Stack, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

import { Text } from 'ui';

interface AccountBalanceProps {
  isMobile: boolean;
  balance: number;
}

const AccountBalance = ({ isMobile, balance = 0 }: AccountBalanceProps) => {
  const {
    colors: {
      palette: {
        components: {
          profileSidebar: { accountBalance: styles }
        }
      }
    }
  } = useTheme();

  if (balance <= 0) {
    return null;
  }

  if (isMobile) {
    return (
      <Stack
        cursor='default'
        gap={0}
        w='100vw'
        maxW='100vw'
        ml='calc(50% - 50vw)'
        bg={styles.amountBg}
        overflow='hidden'
        alignItems='center'
        borderRadius={0}
        py='10px'
        minH='50px'
        justifyContent='center'
      >
        <Flex alignItems='center' justifyContent='center' w='100%'>
          <Stack
            flexDirection='row'
            justifyContent='center'
            flexWrap={{ base: 'wrap', sm: 'nowrap' }}
            alignItems='center'
            px={{ base: '50px', sm: '0' }}
            gap='6px'
            flex={1}
          >
            <Text
              fontSize='12px'
              textTransform='uppercase'
              textAlign='center'
              lineHeight='10px'
              pt={{ base: '4px', sm: 0 }}
              color={styles.amountColor}
            >
              Account Balance
            </Text>

            <Text
              as='span'
              fontSize='18px'
              fontWeight='semibold'
              textAlign='center'
              color={styles.amountColor}
            >
              {formatCurrency(balance)}
            </Text>
          </Stack>
        </Flex>
      </Stack>
    );
  }

  return (
    <Stack
      cursor='default'
      gap={0}
      mt='15px'
      bg={styles.amountBg}
      overflow='hidden'
      alignItems='center'
      borderRadius='3px'
      justifyContent='center'
    >
      <Flex
        py='4px'
        justifyContent='center'
        alignItems='center'
        bg={styles.titleBg}
        paddingX='17px'
        w='100%'
      >
        <Text
          fontSize='12px'
          textTransform='uppercase'
          color={styles.titleColor}
        >
          Account Balance
        </Text>
      </Flex>
      <Flex
        alignItems='center'
        justifyContent='center'
        pl='17px'
        pr='12px'
        py='16px'
        gap='13px'
        w='100%'
      >
        <Text
          as='span'
          fontSize='22px'
          fontWeight='semibold'
          textAlign='center'
          color={styles.amountColor}
          flex={1}
        >
          {formatCurrency(balance)}
        </Text>
      </Flex>
    </Stack>
  );
};

export default memo(AccountBalance);
